// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#taisteal-sidebar {
    max-width: min(94%, 500px);
    min-width: 200px;
    max-height: 94%;
    box-sizing: content-box;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1rem;
    color: #ffffff;
    padding-right: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    padding-top: 10px;
    min-height: 10%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-end; 
    overflow-x: hidden;
    overflow-y: auto;
}

.taisteal-sidebar-panel {
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 10px;
    margin-top: 10px;
    width: 100%;
    /*box-shadow: 0 0 5px 5px rgb(255 255 255 / 0.08);*/
    border-color: #000;
    border-width: 1px;
    overflow-x: auto;
    overflow-y: hidden;
    /* Prevent user selections, because they happen by accident when you
     * interact with the globe. */
    -webkit-user-select: none;
            user-select: none;

    background-color: #dfdde5;
    color: #333;
}

.taisteal-sidebar-button {
    width: -moz-fit-content;
    width: fit-content;
    padding-top: 5px;
    padding-bottom: 5px;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    margin-top: auto;
    margin-bottom: auto;
}

.taisteal-sidebar-icon {
    display: inline;
    font-size: 1.2em;
    stroke-width: 0.1;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,yCAAyC;IACzC,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IAEjB,eAAe;IACf,eAAe;IACf,OAAO;IACP,SAAS;IACT,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,mDAAmD;IACnD,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB;iCAC6B;IAC7B,yBAAiB;YAAjB,iBAAiB;;IAEjB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":["#taisteal-sidebar {\n    max-width: min(94%, 500px);\n    min-width: 200px;\n    max-height: 94%;\n    box-sizing: content-box;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: 1rem;\n    color: #ffffff;\n    padding-right: 10px;\n    padding-left: 10px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n    overflow-x: hidden;\n    min-height: 10%;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-content: flex-start;\n    justify-content: flex-end; \n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.taisteal-sidebar-panel {\n    border-radius: 5px;\n    padding: 10px 15px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    width: 100%;\n    /*box-shadow: 0 0 5px 5px rgb(255 255 255 / 0.08);*/\n    border-color: #000;\n    border-width: 1px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    /* Prevent user selections, because they happen by accident when you\n     * interact with the globe. */\n    user-select: none;\n\n    background-color: #dfdde5;\n    color: #333;\n}\n\n.taisteal-sidebar-button {\n    width: fit-content;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    box-sizing: border-box;\n    text-align: center;\n    text-decoration: none;\n    vertical-align: middle;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.taisteal-sidebar-icon {\n    display: inline;\n    font-size: 1.2em;\n    stroke-width: 0.1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
